import { TextProps } from "./Text.types";

export default function Text({
  level = "p",
  className = "",
  children,
  style,
}: TextProps) {
  const Tag = level;
  return <Tag className={className}>{children}</Tag>;
}
